/**
 *
 * Asynchronously loads the component for LoginPage
 *
 */

import { lazyLoad } from "src/utils/loadable";

export const HomePage = lazyLoad(
  () => import("./index"),
  (module) => module.Home
);
